export const WATCH_HISTORY_ACTION = 'WATCH_HISTORY_ACTION';
export const WATCH_HISTORY_SUCCESS_ACTION = 'WATCH_HISTORY_SUCCESS_ACTION';
export const WATCH_HISTORY_FAILURE_ACTION = 'WATCH_HISTORY_FAILURE_ACTION';
